import { EmployeeDto, getEmptyEmployeeDto } from './user/userTypes';
import { ChoiceDto } from './choiceTypes';
import { QuestionDto } from './questionTypes';
import { ColumnAnswerDto } from './columnAnswerTypes';
import { BaseQuestionnaire } from './questionnaire/questionnaireTypes';
import { BaseModule } from './questionModuleTypes';
import { BaseCluster } from './questionClusterTypes';
import { CommentDto } from '../components/questionnaire/answeredQuestionnaire/commentTypes';
import { emptyQuestionCatalogue } from './questionCatalogue/qustionCatalogueTypes';
import { Positioned } from './positionedTypes';

export interface AnsweredQuestionnaireDto extends BaseQuestionnaire {
  modules: AnsweredModule[]
}

export interface AnsweredModule extends BaseModule {
  position: number,
  clusters: AnsweredCluster[]
}

export interface AnsweredCluster extends BaseCluster, Positioned {
  questions: AnsweredQuestionDto[]
}

export interface AnsweredQuestionDto extends QuestionDto, Positioned {
  comment?: CommentDto,
  personalizedAnswers: PersonalizedAnswer[]
}

export interface PersonalizedAnswer {
  employee: EmployeeDto,
  answer?: string,
  choice?: ChoiceDto,
  columnAnswers?: ColumnAnswerDto[]
}

export function emptyAnsweredQuestionnaire(): AnsweredQuestionnaireDto {
  return {
    id: 0,
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    anonymous: false,
    appraisee: getEmptyEmployeeDto(),
    appraisers: [],
    catalogue: emptyQuestionCatalogue(),
    modules: []
  }
}
